<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Stammdaten') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="customer_number" v-model="form.customer_number" :error="form.errors.customer_number" />
                            <select-input label="customer_group_id" v-model="form.customer_group_id" >
                                <option :value="null">{{ __('Keine') }}</option>
                                <option :value="customerGroup.id" v-for="customerGroup in customerGroups">{{ customerGroup.name }}</option>
                            </select-input>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Adresse') }}</legend>
                            <div class="row">
                                <div class="col-8">
                                    <text-input label="street" v-model="form.street" :error="form.errors.street" />
                                </div>
                                <div class="col-4">
                                    <text-input label="house_number" v-model="form.house_number" :error="form.errors.house_number" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <text-input label="zip_code" v-model="form.zip_code" :error="form.errors.zip_code" />
                                </div>
                                <div class="col-8">
                                    <text-input label="city" v-model="form.city" :error="form.errors.city" />
                                </div>
                            </div>
                            <select-input label="country_id" v-model="form.country_id" >
                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                            </select-input>
                            <text-input label="vat_id" v-model="form.vat_id" :error="form.errors.vat_id" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Kontakt') }}</legend>
                            <text-input type="email" label="email" v-model="form.email" :error="form.errors.email" />
                            <text-input type="tel" label="phone" v-model="form.phone" :error="form.errors.phone" />
                            <text-input type="tel" label="fax" v-model="form.fax" :error="form.errors.fax" />
                            <text-input type="url" label="website" v-model="form.website" :error="form.errors.website" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Sonstiges') }}</legend>
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="customer">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'customer',
            'countries',
            'customerGroups',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.customers.destroy', this.customer));
            },
        },
    }
</script>
